import { Id, Agreement, ResponseDataPaginate } from 'src/types'

import Api, { make, Response } from '.'

type ResponseAgreements = ResponseDataPaginate & {
  agreements: Agreement[]
}

export function getAgreements(
  page: number,
  organization_id: Id,
  pageSize: number = 10
): Promise<Response<ResponseAgreements>> {
  return make<ResponseAgreements>({
    axiosCall: Api.get(
      `/organizations/${organization_id}/agreements?page_size=${pageSize}&page=${page}`
    )
  })
}

export function setAgreements(
  agreement: Agreement,
  organization_id: Id
): Promise<Response<ResponseAgreements>> {
  return make<ResponseAgreements>({
    axiosCall: Api.post(`/organizations/${organization_id}/agreements`, {
      agreements: [agreement]
    })
  })
}
